"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { cn } from "@pulsex/utils";
import authenticateAdmin from "../lib/auth";
export default function AdminLogin(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await authenticateAdmin(email, password);
        if (res) {
            console.log("success");
        }
        else {
            console.log("failed");
        }
    };
    return (React.createElement("div", Object.assign({ className: cn("flex flex-col gap-6 container mx-auto my-10 text-black h-[calc(100dvh-360px)]", className) }, props),
        React.createElement(Card, { className: "w-full md:w-[400px] bg-white mx-auto mt-5" },
            React.createElement(CardHeader, null,
                React.createElement(CardTitle, { className: "text-2xl" }, "Admin Login"),
                React.createElement(CardDescription, null, "Enter your credentials to enter editing mode")),
            React.createElement(CardContent, null,
                React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement("div", { className: "flex flex-col gap-6" },
                        React.createElement("div", { className: "grid gap-2" },
                            React.createElement(Label, { htmlFor: "email" }, "Email"),
                            React.createElement(Input, { id: "email", type: "email", placeholder: "m@example.com", required: true, value: email, onChange: (e) => setEmail(e.target.value) })),
                        React.createElement("div", { className: "grid gap-2" },
                            React.createElement("div", { className: "flex items-center" },
                                React.createElement(Label, { htmlFor: "password" }, "Password"),
                                React.createElement("a", { href: "#", className: "ml-auto inline-block text-sm underline-offset-4 hover:underline" }, "Forgot your password?")),
                            React.createElement(Input, { id: "password", type: "password", required: true, value: password, onChange: (e) => setPassword(e.target.value) })),
                        React.createElement(Button, { type: "submit", className: "w-full" }, "Login")))))));
}
